import { useQuery } from '@tanstack/react-query';

import { useAppDispatch } from 'store';

import { ITopicTests } from '../models';
import { getTopicTestById } from '../queries';
import { setTestInfo, topicTestsConst } from '..';

export const useTopicTestById = (id?: string | string[] | undefined) => {
  const dispatch = useAppDispatch();

  return useQuery<ITopicTests>({
    queryKey: [topicTestsConst.queryKeys.USE_TOPIC_TEST_BY_ID, id],
    queryFn: () => getTopicTestById(id),
    onSuccess: data => {
      dispatch(setTestInfo(data));
    },
    enabled: !!id
  });
};
